/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */

/**
 * The lifecycle status to move the nursery to. ACTIVE and DISABLED are reversible; ARCHIVED is permanent.
 */
export enum ChangeNurseryStatusDtoStatus {
  ACTIVE = "ACTIVE",
  DISABLED = "DISABLED",
  ARCHIVED = "ARCHIVED",
}
